export default __webpack_public_path__ + "static/media/10-10_icon.5a90c0fc.svg";